export enum Mode {
    DISPLAY = 'Display',
    INPUT = 'Input',
    INPUT_NOWARN = 'InputNoWarn',
}
